import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EncuestaService {

  idEmpresa: string;
  idUsuario: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private httpClient:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getCompanyID():string{
    const token = localStorage.getItem('companyID');
    return token;
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  // getStatusAbiertas(anio: number){
  //   let datos: any = {fechaCertificar: anio,	abiertas: 1};
  //   return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  // }
  //
  // guardaStatusAbiertas(anio: number){
  //   let datos: any = {fechaCertificar: anio,	abiertas: 3};
  //   return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  // }
  //
  // // TRADUCCIONES DE PREGUNTAS ABIERTAS
  //  getTraducciones(data){
  //   return this.http.post(DATOS_API.url + DATOS_API.endpoints.abiertas.getTraducciones+this.idEmpresa,data);
  //   // return this.httpClient.post(this.ip+'/api_empresa/getTraduccionesAbiertas/'+this.getCompanyID(),data,
  //   // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  // }




  getPilotoDataEncuesta(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.envioCorreo.getPilotoData+this.getCompanyID(),data);
  }

  getPilotoDataEncuesta_estatus(data,idEmpresa){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.envioCorreo.getPilotoData+idEmpresa,data);
  }



  getStatusEncuesta(productoId:any){
    this.obtienInfo();
    let datos: any = {productoId,	encuesta: 1};
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusEncuesta(datos){
    this.obtienInfo();
    console.log(datos);
    // let datos: any = {fechaCertificar: anio,	encuesta: 3};
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  DesbloquearPasoEncuesta(datos){
    this.obtienInfo();
    console.log(datos);
    // let datos: any = {fechaCertificar: anio,	encuesta: 2};
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  activarDesbloqueoPasos(idEmpresa: any, idProducto: any, datos:any){
    this.obtienInfo();
    let empresaId;
    if(idEmpresa.length>0){
      empresaId=idEmpresa;
    }
    else{
      empresaId=this.idEmpresa;
    }
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.desbloqueoPasos.activarFuncion + empresaId+'/'+idProducto, datos);
  }

  estatusDesbloqueoPasos(idEmpresa: any, idProducto: any){
    this.obtienInfo();
    let empresaId;
    if(idEmpresa.length>0){
      empresaId=idEmpresa;
    }
    else{
      empresaId=this.idEmpresa;
    }
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.desbloqueoPasos.consultarStatus + empresaId+'/'+idProducto);
  }



  activarMostrarCajasCerPortal(idEmpresa: any, idProducto: any, datos:any){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.mostrarResultCerPort.updateactidesFuncion + idEmpresa+'/'+idProducto, datos);
  }

  estatusMostrarCajasCerPortal(idEmpresa: any, idProducto: any){
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.mostrarResultCerPort.consultarStatus + idEmpresa+'/'+idProducto);
  }


  ///////////*********************crearencuesta**************************//////////////
  getBanderas(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getBaderasEncuesta + this.getCompanyID(),data);
  }
  crearEncuesta(data){
this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.postCrearEnc+this.idEmpresa,data);
  }

  crearEncuesta2(data){
this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.postCrearEnc2+this.idEmpresa,data);
  }
  crearEncuesta3_0(data){
this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.postCrearEnc3 + this.idEmpresa, data);
  }

  saveUsuarios(data){
this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.certificar2.guardarUsuariosDemo+this.idEmpresa,data);
  }
  saveUsuariosBD(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveUsuarios+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveUsuarios/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  ///***secciones//
  saveNPS(data){
    this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveNPS+this.idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveNPS/'+this.idEmpresa,data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }
  saveNPSCONTROL(data){
    this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveNPSCONTROL+this.idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveNPS/'+this.idEmpresa,data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  saveReactivos(data){
    this.obtienInfo();
    console.log('Enviando peticion /api_empresa/saveReactivos/');
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveReactivos+this.idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveReactivos/'+this.idEmpresa,data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  saveControl(data){
    this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveControl+this.idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveControl/'+this.idEmpresa,data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  saveDemograficos(data){
this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveDemograficos+this.idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveDemograficos/'+this.idEmpresa,data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  saveAdicionales(data){
this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveAdicionales+this.idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveAdicionales/'+this.idEmpresa,data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  saveAbiertas(data){
this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveAbiertas+this.idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveAdicionales/'+this.idEmpresa,data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  saveForall(data){
this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveForall+this.idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/saveForall/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  getStatusSecciones(data){
    this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getSeccionesCertificar+this.idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/Certificar/secciones/get/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  getEstatusEncuesta(data){
    this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.getEstatusEncuesta+this.idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/getEstatusEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  registerDate2(data){
    this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.postProgramarEnc2+this.idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/programarEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  getEstatusEncuesta2(){
    this.obtienInfo();
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.shedule.getEstatusEncuesta2 + this.idEmpresa + "/" + localStorage.getItem('productoID'));
  }


  ////////// SERVICIOS CREACION DE ENCUESTA DE MEDIR
  getEstatusEncuestaMedir(data){
    console.log(data);
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medir.shedule.getEstatusEncuesta+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/getEstatusEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }
  crearEncuesta_Medir(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medir.shedule.postCrearEnc+this.getCompanyID(),data);
  }

  saveUsuarios_Medir(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medir.shedule.saveUsuarios+this.getCompanyID(),data);
  }

  applyUsuarios_Medir(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.applyUsuarios+this.getCompanyID(),data);
  }

  saveNPS_Medir(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveNPS+this.getCompanyID(),data);
  }

  saveReactivos_Medir(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medir.shedule.saveReactivos+this.getCompanyID(),data);
  }

  saveControl_Medir(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medir.shedule.saveControl2+this.getCompanyID(),data);
  }

  saveDemograficos_Medir(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveDemograficos+this.getCompanyID(),data);
  }

  saveAdicionales_Medir(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveAdicionales+this.getCompanyID(),data);
  }

  saveAbiertas_Medir(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveAbiertas+this.getCompanyID(),data);
  }

  saveForall_Medir(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveForall+this.getCompanyID(),data);
  }

  ///////////////// MDIRES NUEVOS
  saveNPSCONTROL_MedirGen(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medirGenerico.saveNPSCONTROL+this.getCompanyID(),data);
  }
  saveReactivos_MedirGen(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medirGenerico.saveReactivos+this.getCompanyID(),data);
  }
  saveControl_MedirGen(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medirGenerico.saveControl+this.getCompanyID(),data);
  }
  saveDemograficos_MedirGen(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medirGenerico.saveDemograficos+this.getCompanyID(),data);
  }
  saveForall_MedirGen(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medirGenerico.saveForall+this.getCompanyID(),data);
  }
  saveAbiertas_MedirGen(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.medirGenerico.saveAbiertas+this.getCompanyID(),data);
  }

  ////////// SERVICIOS CREACION DE ENCUESTA DE PULSE CHECK
  getEstatusEncuesta_Pulse(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.pulse.getProgressEnc+this.getCompanyID(),data);
  }
  crearEncuesta_Pulse(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.pulse.postCrearEnc+this.getCompanyID(),data);
  }

  saveUsuarios_Pulse(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.pulse.saveUsuarios+this.getCompanyID(),data);
  }

  applyUsuarios_Pulse(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.applyUsuarios+this.getCompanyID(),data);
  }

  saveReactivos_Pulse(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.pulse.saveReactivos+this.getCompanyID(),data);
  }

  saveControl_Pulse(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.pulse.saveControl+this.getCompanyID(),data);
  }

  saveDemograficos_Pulse(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.Focus.saveDemograficos+this.getCompanyID(),data);
  }

  ////////// SERVICIOS CREACION DE ENCUESTA DE FOCUS AREA
  getBanderasFocus(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.Focus.getBaderasEncuestaFocus+this.getCompanyID(),data);
  }
  getBanderasFocus_req(data,idEmpresa){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.Focus.getBaderasEncuestaFocus+idEmpresa,data);
  }
  getEstatusEncuesta_Focus(){
    let data={name:"hola"}
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.Focus.getEstatusEncuestaFocus+localStorage.getItem('encuestaID'),data);
  }
  crearEncuesta_Focus(){
    let data={nom:"hola"}
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.Focus.postCrearEnc+localStorage.getItem('encuestaID'),data);
  }
  saveUsuarios_Focus(){
    let data={nom:"hola"}
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.Focus.saveUsuarios+localStorage.getItem('encuestaID'),data);
  }
  saveReactivos_Focus(data){
    let datos:any= " ";
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.Focus.saveReactivos+data,datos);
  }
  // saveAdicionales_Focus(data){
  //   let datos:any= " ";
  //   return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveAdicionalesFocus+data,datos);
  // }
  saveAdicionales_Focus(data){
    let datos:any= " ";
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.saveAdicionalesFocus2+data,datos);
  }

  //SERVICIOS DE AVISOS
  getAviso(){
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.avisos.getAviso + this.getCompanyID() + "/" + localStorage.getItem('productoID'));
  }
  getAvisoFocus(){
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.avisos.getAviso + this.getCompanyID() + "/" + localStorage.getItem('encuestaID'));
  }
  setAviso(datos:any){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.avisos.setAviso + this.getCompanyID() + "/" + localStorage.getItem('productoID'), datos);
  }

  getAvanceEncuesta(data,idEmpresa){
    console.log(data);
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.cierre.getAvanceEncuesta+idEmpresa,data);
  }

  getAsignacionUsuarioDemo(claveDemo){
    console.log(claveDemo);
    let datos=''
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.certificar2.seccionCrearEncuesta.asignacionUsuarioDemo+this.getCompanyID() + "/" + localStorage.getItem('productoID')+'/'+claveDemo,datos);
  }


  getHistoriaCreacionEncuesta(){
    let tipo=2;
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.historialesCer3.getHistorialColActCrea+localStorage.getItem('productoID') + "/"+tipo);
  }

actualizaNombreURL(datos){
console.log(datos);

  return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.certificar3.seccionCrearEncuesta.actualizarCustomShortURL+this.getCompanyID(),datos);
  }

limitCaracterNameURL(){
  return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.certificar3.seccionCrearEncuesta.limitCustomShortURL);
  }

  sendEmailReqTecnicos(idEmpresa,productoID,datos){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.sendEmailRequerimientosTecnicos + idEmpresa+'/'+productoID,datos);
  }

  crearEncuestaSeccionesCer3(data){
    this.obtienInfo();
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.certificar3.seccionCrearEncuesta.crearEncuestaCer3+this.idEmpresa,data);

  }

  urlCodigoQR(){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.surveyUrlQR + localStorage.getItem('companyID'), { productoId: localStorage.getItem('productoID') });
  }

  getUserSeccionEspecial(){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.certificar3.seccionCrearEncuesta.getUserSeccionEspecial + localStorage.getItem('companyID'), { productoId: localStorage.getItem('productoID') });
  }

  reasignarSeccionesEspeciales(){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.certificar3.seccionCrearEncuesta.reasignarSeccionesEspeciales, { productoId: localStorage.getItem('productoID') });
  }
  getIdiomasTemplateEmailRT(idBroker:any,tipo:any){
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getIdiomasTemplateEmailRT+idBroker+'/'+tipo);
  }
  postIdiomasCertiPlata(datos:any){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.saveJsonsSilverCert+this.idEmpresa,datos);
  }

}
